import React from 'react';
import useApi from './useApi';

const BASE_URL = '/profile';

export const useProfile = () => {
  const { get, post, put, remove: removeData } = useApi();

  /** List all profiles */
  const list = React.useCallback(async () => {
    const profiles = await get(BASE_URL);
    return profiles;
  }, [get]);

  /** Load a profile */
  const load = React.useCallback(
    async id => {
      const loadedProfile = get(`${BASE_URL}/${id}`);
      return loadedProfile;
    },
    [get],
  );

  /** Create a profile */
  const create = React.useCallback(
    async newProfile => {
      const createdProfile = await post(BASE_URL, newProfile);
      return createdProfile;
    },
    [post],
  );

  /** Update a new user */
  const update = React.useCallback(
    async (profileId, profile) => {
      const updatedProfile = put(`${BASE_URL}/${profileId}`, profile);
      return updatedProfile;
    },
    [put],
  );

  /** Remove a new user */
  const remove = React.useCallback(
    async profileId => {
      const deletedProfile = removeData(`${BASE_URL}/${profileId}`);
      return deletedProfile;
    },
    [removeData],
  );

  /** Get a profile list to show in combo */
  const getProfilesItemCombo = React.useCallback(async () => {
    const profiles = await get(`${BASE_URL}?active=true`);
    return !profiles.length
      ? []
      : profiles.map(({ _id, description }) => ({
          _id,
          label: description,
        }));
  }, [get]);

  /** Add a item menu on profile */
  const addItem = React.useCallback(
    async (profileId, item) => {
      const updatedProfile = await put(
        `${BASE_URL}/${profileId}/addItem`,
        item,
      );
      return updatedProfile;
    },
    [put],
  );

  /** Remove a item menu from profile */
  const removeItem = React.useCallback(
    async (profileId, item) => {
      const updatedProfile = await put(
        `${BASE_URL}/${profileId}/removeItem`,
        item,
      );
      return updatedProfile;
    },
    [put],
  );

  return {
    list,
    load,
    create,
    update,
    remove,
    addItem,
    removeItem,
    getProfilesItemCombo,
  };
};

export default useProfile;
